import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as _redux from './setup';
import store from './setup/redux/Store';
import axios from 'axios';
import { App } from './app/App';
import { MetronicI18nProvider } from './rbts/i18n/Metronici18n';

import './rbts/assets/sass/style.scss';
import './rbts/assets/sass/style.react.scss';

const { PUBLIC_URL } = process.env;

_redux.setupAxios(axios, store);

ReactDOM.render(
  <MetronicI18nProvider>
    <Provider store={store}>
        <App basename={PUBLIC_URL} />
    </Provider>
  </MetronicI18nProvider>,
  document.getElementById('root')
);
